let items = document.querySelector('.header__inline-menu').querySelectorAll('details');
for (const item of items) {
  item.addEventListener('mouseover', () => {
    item.setAttribute('open', true);
    item.querySelector('ul').addEventListener('mouseleave', () => {
      item.removeAttribute('open');
    });
    item.addEventListener('mouseleave', () => {
      item.removeAttribute('open');
    });
  });
}

document.querySelectorAll('details').forEach((detail) => {
  detail.addEventListener('toggle', function () {
    if (this.open) {
      const submenu = this.querySelector('.header__submenu--customDrawer');
      if (submenu) {
        submenu.setAttribute('open', '');
      }
    } else {
      const submenu = this.querySelector('.header__submenu--customDrawer');
      if (submenu) {
        submenu.removeAttribute('open');
      }
    }
  });
});
